export default (state, city) => {
  state.city = city;
}
